import clsx from "clsx";
import type { HTMLAttributes } from "react";
import { forwardRef } from "react";

import styles from "./item.module.css";

type Props = HTMLAttributes<HTMLSpanElement>;

const ItemContent = forwardRef<HTMLSpanElement, Props>(({ children, className, ...otherProps }, ref) => {
    return (
        <span {...otherProps} ref={ref} className={clsx(styles.item_content, className)}>
            {children}
        </span>
    );
});

ItemContent.displayName = "ItemContent";

export { ItemContent };
export type { Props as ItemContentProps };
